<div id="module-notification" [@fadeInOut]="state">
  <div [class]="styles">
    <i class="icon-notification"></i>
    <div>
      <h2>{{ title }}</h2>
      <span [innerHTML]="message"></span>
    </div>
  </div>
</div>
